// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"f64dcb93","167":"a2e03527","210":"d890f0aa","244":"95243327","436":"81b01c2c","513":"743fe869","703":"df193ff6","808":"dc4eb1b3","835":"669840e2","896":"7440caba"}[chunkId] + ".chunk.js";
};